import { isInViewport } from "./helperFunctions";
import { trackStructEvent } from "@rtl_nl/rtl-snowplow";
import { globalVars } from "./variables";

/**
 *
 */
function initHomePageTracking() {
    /**
     * show interactions, sends event whenever section is in view
     */
    const sectionOffer = document.querySelector(".home-intro");
    const sectionVlContent = document.querySelector(".row-auto-scroll-titels");
    const sectionRandom = document.querySelector(".row-titel-genres-filter");
    const sectionTier = document.querySelector(".et_pb_rtl_tiering");
    const sectionReality = document.querySelector(".row-navigation-titels");
    const sectionAwardWinning = document.querySelector(
        ".row-double-row-titels"
    );
    const sectionUniqueStreaming = document.querySelector(
        ".section-unique-streaming"
    );
    const sectionDownloadToGo = document.querySelector(
        ".section-download-to-go"
    );
    const sectionCancel = document.querySelector(".section-cancel");
    const sectionFamily = document.querySelector(".section-family");
    const sectionFaq = document.querySelector(".section-faq");

    document.addEventListener("scroll", () => {

        if (sectionOffer) {
            isInViewport(sectionOffer) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-offer",
                        elementGroup: "section-offer",
                        elementType: "section",
                    },
                });
        }
        if (sectionVlContent) {
            isInViewport(sectionVlContent) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-vl-content",
                        elementGroup: "section-vl-content",
                        elementType: "section",
                    },
                });
        }
        if (sectionRandom) {
            isInViewport(sectionRandom) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-random",
                        elementGroup: "section-random",
                        elementType: "section",
                    },
                });
        }
        if (sectionTier) {
            isInViewport(sectionTier) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-tier",
                        elementGroup: "section-tier",
                        elementType: "section",
                    },
                });
        }
        if (sectionReality) {
            isInViewport(sectionReality) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-reality",
                        elementGroup: "section-reality",
                        elementType: "section",
                    },
                });
        }
        if (sectionAwardWinning) {
            isInViewport(sectionAwardWinning) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-award-winning",
                        elementGroup: "section-award-winning",
                        elementType: "section",
                    },
                });
        }
        if (sectionUniqueStreaming) {
            isInViewport(sectionUniqueStreaming) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-unique-streaming",
                        elementGroup: "section-unique-streaming",
                        elementType: "section",
                    },
                });
        }
        if (sectionDownloadToGo) {
            isInViewport(sectionDownloadToGo) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-download-to-go",
                        elementGroup: "section-download-to-go",
                        elementType: "section",
                    },
                });
        }
        if (sectionCancel) {
            isInViewport(sectionCancel) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-cancel",
                        elementGroup: "section-cancel",
                        elementType: "section",
                    },
                });
        }
        if (sectionFamily) {
            isInViewport(sectionFamily) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-family",
                        elementGroup: "section-family",
                        elementType: "section",
                    },
                });
        }
        if (sectionFaq) {
            isInViewport(sectionFaq) &&
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: "section-faq",
                        elementGroup: "section-faq",
                        elementType: "section",
                    },
                });
        }
    });

    // General click listener.
    // For performance, we don't want to add a clack listener on each element,
    // but rather look at the event target of the click
    document.addEventListener("click", (e) => {

        /**
         * click on the main CTA buttons
         */
        if (
            e.target === document.querySelector(".row-ctas a.btn:not(.btn-bw)")
        ) {
            trackStructEvent({
                appId: globalVars.app_id,
                category: "homepage",
                action: "start-trial",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "section-offer",
                    elementType: "button",
                    elementName: "cta-trial",
                    elementLabel: "Probeer het 14 dagen",
                    elementStyle: "primary"
                },
            });
            return;
        }

        if (e.target === document.querySelector(".row-ctas a.btn.btn-bw")) {
            trackStructEvent({
                appId: globalVars.app_id,
                category: "homepage",
                action: "start-catchup",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "section-offer",
                    elementType: "button",
                    elementName: "cta-catchup",
                    elementLabel: "Heractiveer abonnement",
                },
            });
            return;
        }

        if (e.target === document.querySelector(".row-ctas a:not(.btn)")) {
            trackStructEvent({
                appId: globalVars.app_id,
                category: "homepage",
                action: "start-tv-gemist",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "header",
                    elementType: "button",
                    elementName: "cta-tv-gemist",
                    elementLabel: "Ontdek TV Gemist",
                    elementStyle: "secondary"
                },
            });
            return;
        }

        /**
         * click on the scroll nudge
         */
        if (e.target === document.querySelector(".nudge")) {
            trackStructEvent({
                appId: globalVars.app_id,
                category: "homepage",
                action: "nudge",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "scroll-nudge",
                    elementType: "nudge",
                    elementName: "scroll-nudge",
                    elementLabel: "Scroll verder",
                },
            });
            return;
        }

        /**
         * click on the titel covers (whole page)
         */
        for (const titleCover of document.querySelectorAll(".cover-anchor")) {
            if (e.target == titleCover) {
                // get elementGroup
                const sectionClass =
                    titleCover.closest(".et_pb_section").className;
                let propertyVal = "";

                if (sectionClass.indexOf("row-auto-scroll-titels") > -1)
                    propertyVal = "section-vl-content";
                else if (sectionClass.indexOf("row-titel-genres-filter") > -1)
                    propertyVal = "section-voor-ieder-wat-wils";
                else if (sectionClass.indexOf("row-reality") > -1)
                    propertyVal = "section-reality";
                else if (sectionClass.indexOf("row-double-row-titels") > -1)
                    propertyVal = "section-awardwinning";
                else if (sectionClass.indexOf("row-family") > -1)
                    propertyVal = "section-family";

                // get title name
                const titleName =
                    titleCover.querySelector("span").innerText || "";

                // get position of cover
                const article = titleCover.closest(".carousel-item");
                const titleWrapper = article.parentElement;
                const titleWrapperChildren = titleWrapper.childNodes;
                let articleIndex = '0';

                for (let i = 0; i<titleWrapperChildren.length; i++) {
                    if (titleWrapperChildren[i] == article) {
                        articleIndex = toString(i+1);
                        break;
                    }
                }

                // send click event to Snowplow
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "click-cover",
                    label: titleName,
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: propertyVal,
                        elementType: "cover",
                        elementName: titleName,
                        elementLabel: titleName,
                        elementStyle: 'cover',
                        elementPosition: articleIndex,
                    },
                });
                return;
            }
        }

        /**
         * click on the filter buttons (genre filter)
         */
        for (const filterButton of document.querySelectorAll(
            ".row-titel-genres-filter .btn"
        )) {
            if (e.target == filterButton) {
                const genre = filterButton.innerText;
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "click-genre",
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: "section-voor-ieder-wat-wils",
                        elementType: "button",
                        elementName: "genre",
                        elementLabel: genre,
                    },
                });
                return;
            }
        }

        /**
         * Selecting a tier in the tiering table, or clicking the 'kies {tier}' button INSIDE the card
         */
        for (const tier of document.querySelectorAll(".tier__card")) {
            if (tier.contains(e.target)) {
                let tierValue = tier.querySelector("a.btn").innerText;
                let tierName = "";

                if (e.target !== tier.querySelector("a.btn")) {
                    tierValue = tierValue.split("Kies ")[1];
                    tierName = "tier-tile";
                } else if (e.target == tier.querySelector("a.btn")) {
                    tierName = tierValue.split("Kies ")[1] + "-tile";
                }

                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "tier",
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: "section-tier",
                        elementType: "button",
                        elementName: tierName,
                        elementLabel: tierValue,
                    },
                });
                return;
            }
        }
        /**
         * selecting a tier with the button underneath the tiles (regular tiles)
         */
        for (const btn of document.querySelectorAll(".tier-selection a.btn")) {
            if (e.target == btn) {
                const tierValue = btn.innerText;
                const tierName = btn.innerText.split("kies ")[1] + "-bottom";

                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "homepage",
                    action: "tier",
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: "section-tier",
                        elementType: "button",
                        elementName: tierName,
                        elementLabel: tierValue,
                    },
                });
                return;
            }
        }

        /**
         * selecting TV gemist with button underneath table
         */
        if (e.target == document.querySelector(".tv-gemist-usps a.btn")) {
            trackStructEvent({
                appId: globalVars.app_id,
                category: "homepage",
                action: "tier",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "section-tier",
                    elementType: "button",
                    elementName: "TV-gemist-bottom",
                    elementLabel: "Kies TV gemist",
                },
            });
            return;
        }

        /**
         * changing between tiering table and tv-gemist table
         */
        if (e.target == document.querySelector(".tiering-toggle-1")) {
            trackStructEvent({
                appId: globalVars.app_id,
                category: "homepage",
                action: "tier",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "section-tier",
                    elementType: "toggle",
                    elementName: "tier-toggle",
                    elementLabel: "Alle series en films",
                },
            });
            return;
        }

        if (e.target == document.querySelector(".tiering-toggle-2")) {
            trackStructEvent({
                appId: globalVars.app_id,
                category: "homepage",
                action: "tier",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "section-tier",
                    elementType: "toggle",
                    elementName: "tier-toggle",
                    elementLabel: "Alleen terugkijken",
                },
            });
            return;
        }
    });
}

export { initHomePageTracking };
